export default {
    routerName: '職位編集',
    post: {
        name: '職位名',
        code: '職位番号',
        sortOrder: 'ソート',
        status: '状態',
        open: '有効',
        close: '無効',
        remark: '備考',
    },
};
